export const getOauthBearerValue = (token) => token ? `Bearer ${token}` : '';
